var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7907_803)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7907_803",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 90,
    height: 90
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 5H5V95H95V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7907_803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 5C25.1411 5 5 25.1411 5 50C5 74.8588 25.1411 95 50 95C74.8588 95 95 74.8588 95 50C95 25.1411 74.8588 5 50 5ZM50 22.4194C58.8186 22.4194 65.9677 29.5685 65.9677 38.3872C65.9677 47.2058 58.8186 54.3549 50 54.3549C41.1814 54.3549 34.0323 47.2058 34.0323 38.3872C34.0323 29.5685 41.1814 22.4194 50 22.4194ZM50 84.8387C39.3488 84.8387 29.8045 80.0122 23.4173 72.4637C26.8286 66.0403 33.5061 61.6128 41.2902 61.6128C41.7259 61.6128 42.1613 61.6854 42.5787 61.8125C44.9375 62.5747 47.4052 63.0646 50 63.0646C52.5948 63.0646 55.0805 62.5747 57.4213 61.8125C57.8387 61.6854 58.2741 61.6128 58.7098 61.6128C66.4939 61.6128 73.1713 66.0403 76.5826 72.4637C70.1954 80.0122 60.6512 84.8387 50 84.8387Z",
    fill: "#0059A9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7907_803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarUser);
export default __webpack_public_path__ + "static/media/avatarUser.6aaf776ea5ca96599e8a32420c762f64.svg";
export { ForwardRef as ReactComponent };